import { capitalized } from "../Formatters";

const formatAttributeInputType = (type, options, attribute) => {
  const hasUnits =
    attribute?.unit?.options?.length !== 0 &&
    (type === "number-entry" || type === "number-entry-with-unit");

  let typeString = "";
  if (type === "ddl") {
    typeString = "List";
  } else if (type === "number-entry") {
    typeString = "Number";
  } else if (type === "text-entry") {
    typeString = "Text";
  } else if (type === "date-picker") {
    typeString = "Date";
  } else if (hasUnits) {
    typeString = "Number with Units";
  } else if (type === "check-box") {
    typeString = "Checkbox";
  } else {
    typeString = type;
  }

  if (options?.length > 0) {
    const optionList = options?.map((item) => {
      return ` ${capitalized(item.label)}`;
    });
    typeString += `: ${optionList}`;
  }
  return typeString;
};

export default formatAttributeInputType;
